import React, { useEffect, useRef, useState } from 'react'
import { useGwGoodsTypeUpdateQuery, useGwGoodsTypeUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import { Form, Input, InputNumber, message, Modal } from 'antd';

function WebGoodsTypeEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState();
    const editForm = useRef()
    const {data,isSuccess} = useGwGoodsTypeUpdateQuery({eowgt_id:props.eowgt_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);
                editForm.current.setFieldsValue({
                    eowgt_name:data.Result.eowgt_name,
                    eowgt_content:data.Result.eowgt_content,
                    eowgt_serial_number:data.Result.eowgt_serial_number,
                })
                setInfo(prevState=>({...prevState,
                    eowgt_name:data.Result.eowgt_name,
                    eowgt_content:data.Result.eowgt_content,              
                    eowgt_serial_number:data.Result.eowgt_serial_number,              
                }))
            }
        }
    },[data,isSuccess])
    const [submitUpdateSave] = useGwGoodsTypeUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {
                setOpen(true)
            }}>修改</a>
            <Modal
                open={open}
                title='修改系统类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    submitUpdateSave({
                        eowgt_name:info.eowgt_name,
                        eowgt_serial_number:info.eowgt_serial_number,
                        eowgt_e_id:localStorage.getItem('e_id'),
                        eowgt_update_uid:localStorage.getItem('eu_id'),
                        eowgt_update_uname:localStorage.getItem('eu_name'),
                        eowgt_id:props.eowgt_id,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 7 }}
                    ref={editForm}
                >
                    <Form.Item name="eowgt_name" label='系统类型' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,eowgt_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="eowgt_serial_number" label='序号' wrapperCol={{span:10}} required>
                        <InputNumber  onChange={(e) => {setInfo(prevState=>({...prevState,eowgt_serial_number:e}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default WebGoodsTypeEdit